import { Formik } from 'formik';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import React, { RefObject } from 'react';
import { Box, Flex } from 'reflexbox';
import moment from 'moment';
import { Panel } from 'primereact/panel';
import { MonitoringRestService } from '../../services/MonitoringRestService';
import { DependencyContainer } from '../../utils/DependencyInjection';
import _ from 'lodash';

export interface IMonitoringFeeFilterContainerValue {
  startDate?: Date;
  endDate?: Date;
  perwakilan?: any;
  branch?: any;
}

export class MonitoringFeeFilterContainer extends React.Component<any, any> {
  monitoringRestService = DependencyContainer.get(MonitoringRestService);
  initialFormValues: IMonitoringFeeFilterContainerValue = {
    startDate: moment().startOf('month').toDate(),
    endDate: moment().endOf('month').toDate(),
    perwakilan: '',
    branch: '',
  };
  refFormik: RefObject<Formik> = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      filterCollapsed: false,
      optionRepresentative: null,
      optionBranch: null,
    }
  }

  componentDidMount() {
    console.log(this.props.showFilter);
    this.monitoringRestService.get("monitoring-penalty/representative/list").subscribe(
      (response) => {
        response = _.map(response, e => {
          return {
            label: e.representative_name + ' (' + e.representative_code + ')',
            value: e.representative_id
          }
        })
        this.setState({
          optionRepresentative: response,
        })
      },
      () => {
        // this.dataSource.loading = false;
      },
      () => {
        // this.dataSource.loading = false;
      }
    );
  }

  getBranchList(data) {
    this.setState({
      optionBranch: null,
    })
    this.refFormik.current!.state.values.branch = '';
    this.monitoringRestService.get("monitoring-penalty/branch/list/" + data.value).subscribe(
      (response) => {
        response = _.map(response, e => {
          return {
            label: e.branch_name + ' (' + e.branch_code + ')',
            value: e.branch_id
          }
        })
        response.push({label: 'Semua', value: ''})
        this.setState({
          optionBranch: response,
        })
      },
      () => {
        // this.dataSource.loading = false;
      },
      () => {
        // this.dataSource.loading = false;
      }
    );
  }

  get formValues() {
    if (this.refFormik.current) {
      return this.refFormik.current.state.values;
    }

    return {};
  }

  render() {
    return (
      <Panel header="Filter" toggleable={true} collapsed={this.state.filterCollapsed} onToggle={(e) => this.setState({ filterCollapsed: e.value })}>
        <div className="row">
          <div className="col-md-12">
            <div>
              <Formik
                ref={this.refFormik}
                enableReinitialize
                initialValues={this.initialFormValues}
                onSubmit={() => { }}>
                {formikProps => (
                  <div className="row">
                    <div className="col-md-12 mb-5">
                      <div className="form-group">
                        <label className="col-md-1">Periode<span style={{color: 'red'}}>*</span></label>
                        <div className="col-md-5">
                          <Calendar
                            name="startDate"
                            readOnlyInput={true}
                            dateFormat="dd-mm-yy"
                            showWeek={true}
                            maxDate={formikProps.values.endDate}
                            onBlur={formikProps.handleBlur}
                            onChange={formikProps.handleChange('startDate')}
                            value={formikProps.values.startDate}
                          />
                          <span className="pr-5 pl-5">s/d</span>
                          <Calendar
                            name="endDate"
                            readOnlyInput={true}
                            dateFormat="dd-mm-yy"
                            showWeek={true}
                            minDate={formikProps.values.startDate}
                            onBlur={formikProps.handleBlur}
                            onChange={formikProps.handleChange('endDate')}
                            value={formikProps.values.endDate}
                          />
                        </div>
                        { this.props.showFilter && (
                          <div>
                            <label className="col-md-2">Perwakilan<span style={{color: 'red'}}>*</span></label>
                            <div className="col-md-2">
                              <Dropdown
                                options={this.state.optionRepresentative}
                                onChange={(e) => {
                                  formikProps.handleChange("perwakilan")(e);
                                  this.getBranchList(e);
                                }}
                                value={formikProps.values.perwakilan}
                                filter={true}
                              />
                            </div>
                          </div>
                          )
                        }
                      </div>
                    </div>
                    { this.props.showFilter && (
                      <div className="col-md-12">
                        <div className="form-group">
                          <label className="col-md-1">Cabang</label>
                          <div className="col-md-2">
                            <Dropdown
                              options={this.state.optionBranch}
                              onChange={formikProps.handleChange("branch")}
                              value={formikProps.values.branch}
                              filter={true}
                            />
                          </div>
                        </div>
                      </div>
                      )
                    }
                    
                    <div className="col-md-12">
                      <div className="form-group">
                        <br/>
                        <br/>
                        <label className="col-md-6"><span style={{color: 'red'}}>*Harus Diisi</span></label>
                      </div>
                    </div>
                  </div>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </Panel>
    );
  }
}
